/* New Arrivals popup — centre box (1 random print) + small corner box.
   Once per visit (sessionStorage). Data comes from #nap-data (snippet). */
(function () {
  'use strict';

  var CFG = {
    delayMs: 6000,          // show centre box after this many ms...
    scrollRatio: 0.4,       // ...or after scrolling this much of the page
    cornerDelayMs: 1200,    // corner box appears this long after the centre box closes
    cornerRotateMs: 20000,  // corner box changes print every N ms
    cornerMaxRotations: 4,
    keyModal: 'nap_modal_seen',
    keyCorner: 'nap_corner_closed'
  };

  var dataEl = document.getElementById('nap-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var pool = (data.products || []).filter(function (p) { return p.id !== data.currentId; });
  if (!pool.length) return;

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }

  // Shuffle once; take prints in order so the centre and corner never repeat.
  for (var i = pool.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
  }
  var cursor = 0;
  function nextProduct() { var p = pool[cursor % pool.length]; cursor++; return p; }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function priceText(p) { return (p.varies ? 'Art print from ' : 'Art print ') + p.price; }
  function otherPopupOpen() {
    // Room preview, or any theme modal/drawer (10% sign-up popup, cart drawer, menu...)
    return document.documentElement.classList.contains('rp-lock') ||
      !!document.querySelector('.modal[open], .drawer[open]');
  }

  /* ---------- Centre box ---------- */
  var modal = null, lastFocus = null;

  function openModal() {
    if (modal || ssGet(CFG.keyModal)) return;
    if (otherPopupOpen()) { setTimeout(openModal, 3000); return; }
    ssSet(CFG.keyModal);
    hideCorner();
    var p = nextProduct();
    lastFocus = document.activeElement;
    var orient = p.ratio > 1.15 ? 'is-landscape' : (p.ratio < 0.87 ? 'is-portrait' : 'is-square');
    // Prefer a room mock-up (print hanging in a room); fall back to the artwork image.
    var room = (p.rooms && p.rooms.length) ? p.rooms[Math.floor(Math.random() * p.rooms.length)] : '';
    var artHtml = room
      ? '<img class="nap-room" src="' + esc(room) + '" alt="' + esc(p.title) + ' art print in a room" width="900" height="900">'
      : '<span class="nap-frame"><img src="' + esc(p.img) + '" alt="' + esc(p.alt) + '" width="900" height="' + Math.round(900 / (p.ratio || 1)) + '"></span>';
    if (room) orient += ' has-room';

    modal = document.createElement('div');
    modal.className = 'nap-overlay';
    modal.innerHTML =
      '<div class="nap-dialog ' + orient + '" role="dialog" aria-modal="true" aria-labelledby="nap-title">' +
        '<button type="button" class="nap-close" aria-label="Close">&times;</button>' +
        '<a class="nap-art" href="' + esc(p.url) + '" data-nap-track="modal-image">' +
          artHtml +
        '</a>' +
        '<div class="nap-info">' +
          '<span class="nap-badge">Just arrived</span>' +
          '<h2 class="nap-title" id="nap-title">' + esc(p.title) + '</h2>' +
          '<p class="nap-price">' + esc(priceText(p)) + '</p>' +
          '<p class="nap-note">A fresh addition to our wall art print collection — choose your size and frame.</p>' +
          '<a class="nap-btn" href="' + esc(p.url) + '">View this print</a>' +
          '<a class="nap-all" href="' + esc(data.allUrl) + '">See all new arrivals &rsaquo;</a>' +
        '</div>' +
      '</div>';

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.nap-close')) closeModal();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(modal);
    document.documentElement.classList.add('nap-lock');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var btn = modal.querySelector('.nap-btn');
      if (btn) btn.focus({ preventScroll: true });
    });
  }

  function onKey(e) {
    if (!modal) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab') { // keep focus inside the dialog
      var f = modal.querySelectorAll('a, button');
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function closeModal() {
    if (!modal) return;
    var m = modal; modal = null;
    document.removeEventListener('keydown', onKey);
    m.classList.remove('is-open');
    document.documentElement.classList.remove('nap-lock');
    setTimeout(function () { m.remove(); }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    setTimeout(showCorner, CFG.cornerDelayMs);
  }

  /* ---------- Corner box ---------- */
  var corner = null, rotateTimer = null, rotations = 0;

  function fillCorner(p) {
    corner.querySelector('.nap-c-link').setAttribute('href', p.url);
    var img = corner.querySelector('.nap-c-img');
    img.src = p.thumb; img.alt = p.alt;
    corner.querySelector('.nap-c-title').textContent = p.title;
    corner.querySelector('.nap-c-price').textContent = 'From ' + p.price;
  }

  function showCorner() {
    if (corner || modal || ssGet(CFG.keyCorner)) return;
    if (otherPopupOpen()) { setTimeout(showCorner, 3000); return; }
    corner = document.createElement('aside');
    corner.className = 'nap-corner';
    corner.setAttribute('aria-label', 'New arrivals');
    corner.innerHTML =
      '<button type="button" class="nap-c-close" aria-label="Close">&times;</button>' +
      '<a class="nap-c-link" href="#">' +
        '<img class="nap-c-img" src="" alt="" width="200" height="200" loading="lazy">' +
        '<span class="nap-c-text">' +
          '<span class="nap-c-label">New in</span>' +
          '<span class="nap-c-title"></span>' +
          '<span class="nap-c-price"></span>' +
          '<span class="nap-c-view">View &rsaquo;</span>' +
        '</span>' +
      '</a>';
    fillCorner(nextProduct());
    corner.querySelector('.nap-c-close').addEventListener('click', function () {
      ssSet(CFG.keyCorner);
      hideCorner();
    });
    document.body.appendChild(corner);
    requestAnimationFrame(function () { corner.classList.add('is-open'); });

    if (pool.length > 2) {
      rotateTimer = setInterval(function () {
        if (!corner || ++rotations > CFG.cornerMaxRotations) { clearInterval(rotateTimer); return; }
        var link = corner.querySelector('.nap-c-link');
        link.classList.add('is-fading');
        setTimeout(function () {
          if (!corner) return;
          fillCorner(nextProduct());
          link.classList.remove('is-fading');
        }, 350);
      }, CFG.cornerRotateMs);
    }
  }

  function hideCorner() {
    clearInterval(rotateTimer);
    if (!corner) return;
    var c = corner; corner = null;
    c.classList.remove('is-open');
    setTimeout(function () { c.remove(); }, 300);
  }

  /* ---------- Start ---------- */
  if (ssGet(CFG.keyModal)) {
    // Centre box already seen this visit: show only the corner box (unless closed).
    setTimeout(showCorner, 3000);
    return;
  }
  var timer = setTimeout(trigger, CFG.delayMs);
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= CFG.scrollRatio) trigger();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  function trigger() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    openModal();
  }
})();
